import { localBounds, type SymbolDef } from '@elec/symbols';

/** Palette preview of a symbol, drawn from the same path data as the canvas. */
export function SymbolIcon({ def, size = 30 }: { def: SymbolDef; size?: number }) {
  const b = localBounds(def);
  const pad = 1.5;
  const w = b.maxX - b.minX + pad * 2;
  const h = b.maxY - b.minY + pad * 2;
  const side = Math.max(w, h);
  const vb = `${b.minX - pad - (side - w) / 2} ${b.minY - pad - (side - h) / 2} ${side} ${side}`;
  return (
    <svg className="symbol-icon" viewBox={vb} width={size} height={size} aria-hidden="true">
      {def.freeText ? (
        <text x={b.minX + 1} y={(b.minY + b.maxY) / 2 + 2} fontSize={7} fill="currentColor">
          Aa
        </text>
      ) : null}
      {def.paths.map((d, i) => (
        <path
          key={i}
          d={d}
          fill="none"
          stroke="currentColor"
          strokeWidth={side / 28}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
      {def.dashed?.map((d, i) => (
        <path
          key={`d${i}`}
          d={d}
          fill="none"
          stroke="currentColor"
          strokeWidth={side / 40}
          strokeDasharray="1 0.8"
        />
      ))}
      {def.fills?.map((d, i) => (
        <path key={`f${i}`} d={d} fill="currentColor" />
      ))}
      {def.texts?.map((tx, i) => (
        <text key={`t${i}`} x={tx.x} y={tx.y} fontSize={tx.size} textAnchor="middle" fill="currentColor">
          {tx.text}
        </text>
      ))}
    </svg>
  );
}
